import { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../Utility/constants";

const useCurrentSession = () => {
  const [currentSession, setCurrentSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSessions = async () => {
      try {        
        const response = await axios.get(`${baseUrl}/api/SessionMaster`);

        const session = response.data.find(
          (x) => x.isCurrentSession === true || x.isCurrentSession === 1
        );

        setCurrentSession(session || null);
      } catch (err) {
        setError("Failed to fetch current session");
      } finally {
        setLoading(false);
      }
    };

    fetchSessions();
  }, []);

  return { currentSession, loading, error };
};

export default useCurrentSession;
